import BaseRecordStatus from '../BaseRecordStatus';

const status = {
  ...BaseRecordStatus,
};

export default status;
